import { QuestionKeyList } from "../../configs/config";

export const lang = {
  slogon: "CONNECTING DOGS FINDING FRIENDS",
  buttons: {
    next: "Next",
    continue: "Continue",
  },
  inputs: {
    emailPattern: "Please enter a valid Email Address",
    emailLenght: "Please enter a shorter Email Address",
    passwordPattern: "Password must made of at least 8 char and upper, lower, number, and special character",
    dogNamePattern: "Dog name must be between 2 and 15 letters.",
    namePattern: "Name must be between 2 and 15 letters.",
  },
  firstVisitPage: {
    buttons: {
      sign_up: "Sign up for free",
    },
    cards: [
      {
        key: 1,
        description: `Help us revolutionise the way our modern dogs socialise`,
      },
      {
        key: 2,
        description: `We’ve compiled the best advice out there to create a gentle method to help dogs make friends!`,
      },
      {
        key: 3,
        description: `Create a profile, get to know the pups in your neighbourhood, and start meeting friends!`,
      },
    ],
  },
  landingPage: {
    form: {
      title: "Login or Sign Up",
      email: {
        label: "EMAIL",
        placeholder: "hello@reallygreatsite.com",
        errors: {
          reuired: "Email is required",
        },
      },
      dogName: {
        label: "ON BEHALF OF",
        placeholder: "Penaut",
      },
    },
    terms_compliance_button: "By logging in, you agree to the terms of use and the privacy policy.",
  },
  signUpPage: {
    slogon: "FOR MODERN DOGS",
    buttons: {
      sign_up: "Sign up",
    },
    form: {
      email: {
        label: "EMAIL",
        placeholder: "hello@reallygreatsite.com",
      },
      dogName: {
        label: "ON BEHALF OF",
        placeholder: "Penaut",
      },
      name: {
        label: "YOUR NAME",
        placeholder: "What can we call you?",
      },
      password: {
        label: "PASSWORD",
        placeholder: "**********",
      },
    },
  },
  logInPage: {
    buttons: {
      log_in: "Login",
      send_reset_link: "Send reset link",
    },
    forget_password: "forgotten password?",
    reset_password_popup: {
      title: "Email sent",
      message: `Shortly you will receive a link to reset your password on your account’s email. If you are having  issues accessing your account, drop us an email at: help@cyno.dog`,
      buttonText: "Exit",
    },
    wrong_password_popup: {
      title: "Wrong password",
      message: `Please try again or reset your password`,
      buttonText: "Continue",
    },
  },
  resetPasswordPage: {
    form: {
      title: "Reset your password",
      password: {
        newPasswordLabel: "new password",
        confirmPasswordLabel: "repeat new password",
        placeholder: "**********",
        errors: {
          reuired: "the repeat password doesn’t match",
          mismatch: "Passwords do not match",
          regexFail: "Password must contain upper, lower, number, and special character",
        },
      },
    },
    successPopup: {
      title: "Success!",
      message: `Your password has been reset successfully, you can now login to your account`,
      buttonText: "Continue",
    },
  },
  addPicturesPage: {
    title: "Add your favourite pictures",
    message: `Adding a selfie of both of you will help with more matches and during dog dates! Good luck choosing only four... `,
  },
  AboutThemPage: {
    title: "Tell us more about them",
    message: `Select some personality traits for your pooch! You’ll be able to add even more details once you have set up your profile!`,
  },
  addYouConnectWithPage: {
    title: "Tell us more about you",
    message: `We're here for dogs and dogs only! And we need to make sure we keep them safe out there. Fill out some basic info, preferences, and get verified to keep your dog extra safe`,
    title2: "Happy to connect with:",
    message2: `Even if this app is for your dog, you might end up finding friends along this canine journey. You can go back at any time to change your settings.`,
  },
  verifyAccountPage: {
    title: "Let’s verify your account",
    message: `You can choose to skip this step for now, and start accessing our dog friendly platform, but a verified account will get more matches!`,
    buttonText1: "Take a picture of your valid ID",
    buttonText2: "Take a selfie to match your ID",
    submited_popup: {
      title: "Thank you!",
      message: `We aim to verify your account in less than 24h, and we will let you know via email once you have been approved. Thanks again for helping us build a safe community for our beloved dogs `,
      buttonText: "Continue",
    },
    buttons: {
      skip: "skip for now",
    },
  },
  swiperPage: {
    geolocationPermissionRequestPopup: {
      title: "Turn on geolocation",
      message: `To find nearby matches we need your location services turned on while using the app. This allows you to meet nearby dogs, in your city and when you’re travelling as well`,
      buttonText: "Continue",
    },
    notificationPermissionRequestPopup: {
      title: "Turn on notifications",
      message: `Get notified of matches, messages and new features as we build CYNO together! You can go to your profile at any time to change or refine this setting`,
      buttonText: "Continue",
      cancelButtonText: "No, Thanks",
    },
    noQuestionLabel: "This user did not add more infos about him",
    pendingAccountVerificationPopup: {
      title: "Pending Account Review",
      message: `Your account in currently being reviewed, if it’s been more than 24h, send a message to Gloudee in the chat!`,
      buttonText: "Ok",
    },
    statutBadgeInfo: {
      title: "Verified!",
      message: `This account has been verified! If you haven’t done so already, you can verify your account in your profile section!`,
      buttonText: "Continue",
    },
    morePopup: {
      title: "More...",
      buttonText: "Report",
      buttonText2: "Block",
    },
    blockPopup: {
      title: "Block this profile",
      message: "By blocking this profile, all informations and content related to this person will be blocked.",
      buttonText: "Confirm",
    },
    reportPopup: {
      title: "Report this profile",
      message: "By reporting this profile, you are alerting on its related content",
      buttonText: "Confirm",
    },
  },
  informationsPage: {
    message: `Here is all the help and advice to help your dog find friends. Step by step guides, the CYNO method and lots more informative content to make your dog’s life fuller.`,
    PageLinkNames: {
      theCynoMethod: "The Gentle Method",
      dogBodyLanguage: "Dog Body Language",
      tipsAndAdvice: "Tips and Advice",
      faq: "FAQs",
    },
  },
  profilePage: {
    title: "PROFILE",
    PageLinkNames: {
      highlights: "Highlights",
      pictures: "Pictures",
      aboutThem: "About them",
      aboutYouConnectWith: "About you/Connect with",
      getVerified: "Get verified",
      deletion: "Delete Account",
    },
    statutBadgeInfo: {
      title: "Verified!",
      message: `Thank you so much for taking the time to make our community safer, you legend!`,
      buttonText: "Continue",
    },
    accountDeletionPopup: {
      title: "Account Deletion!",
      message: "Once you confirm, your account will be deleted after 90 days unless you sign in again before that time",
      buttonText: "Confirm",
    },
  },
  settingsPage: {
    title: "SETTINGS",
    PageLinkNames: {
      distance: "Distance",
      notifications: "Notifications",
      termOfUse: "Term of use",
    },
    buttonLabel: {
      logout: "Log out",
      bugReport: "Report a bug",
      contact: "Contact",
    },
  },
  highlightPage: {
    title: "HIGHLIGHTS",
    message: "Select up to 3 highlights for your best friend’s profile",
  },
  picturesPage: {
    title: "PICTURES",
    message:
      "Good luck choosing a maximum of 5 of your favourite pictures. Surely one of the 15,000 pics stored on your phone will do?",
  },
  updateAboutYouConnectWithPage: {
    title: "YOU/CONNECT",
  },
  updateAboutThemPage: {
    title: "ABOUT THEM",
    message: `This part is fully up to you. You can keep it short and simple, or go into more details. There are three suggested section titles for inspiration!`,
    questions: [
      {
        key: QuestionKeyList.aboutThem,
        title: "About me",
        placeholder: `I’m a 5 years old red Cocker spaniel. I’m a happy chap who loves woodland walks.`,
      },
      {
        key: QuestionKeyList.myDreamDay,
        title: "My Dream Day",
        placeholder: `Leave bright and early to go explore a forest, and have a picnic along the pond to do some bird watching! `,
      },
      {
        key: QuestionKeyList.myFavThings,
        title: "My favourite things",
        placeholder: `I love cheese and rolling in the mud.`,
      },
    ],
  },
  distancePage: {
    title: "DISTANCE",
    message: "Slide the cursor to set the maximum radius for local matches",
    title2: "Radius",
    distanceUnit: {
      km: "Km",
      mile: "Miles",
    },
  },
  notificationsPage: {
    title: "Notifications",
    notifViaEmail: "Notifications via email",
    matchs: "Matches",
    messages: "Messages",
  },
  matchHappeningPage: {
    label1: `It's a`,
    label2: `match`,
    title: "Boop the snoot to start",
  },
  warningMatchPage: {
    text1: `Ready to start making friends with Ivy? Time to get in touch with Ivy’s pet parent and set a first date!`,
    text2: `Remember to meet in a safe place, during the day in a frequented area, and never exchange personal information.`,
    buttons: [
      { normalText: "I read ", strongText: "The Gentle Method" },
      { normalText: "I understand my", strongText: "Dog Body Language" },
    ],
  },
  chatithPage: {
    warningMessage: `We want to keep things extra safe for you and your dog. Never share personal details before becoming real life friends!`,
  },
  staffMatchHappeingPage: {
    text1: `You’ve been matched with Gloudee. You can find her in the chat! Ask her any questions you may have on  your friendship journey!`,
  },
};
